<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
a{
	text-decoration: none;
	color: #333;
}
/*#app{
	background-color: #f0f5f6;
}  */
.bb{
	background-color: #44c1de;
	border:1px solid #44c1de;
	padding: 8px 15px;
}
.bc{
	border: 1px solid #44C1DE;
	color: #44C1DE;
	
}
.dialog-footer{
	text-align: center;
}
.el-button--primary {
    color: #fff;
    background-color: #44c1de;
    border-color: #44c1de;
}
.el-radio__input.is-checked .el-radio__inner {
    border-color: #44c1de;
    background: #44c1de;
}
.el-table th{
    background:rgb(97, 107, 136) !important;
    color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue